import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { VendorContext } from "../../../context/vendor/VendorContext";
import { ContactContext } from "../../../context/contact/ContactContext";
import SaveIcon from "@mui/icons-material/Save";
import stylesCss, {
  AddButton,
  AlertSpan,
  BorderContainer,
  BoxDialog,
  ButtonCancel,
  ContentDialog,
  ContractorContainer,
  ContractorCssTextField,
  ContractorThreeColumn,
  H5,
  LabelH6,
  Root,
  ThreeColumn,
  TwoColumn,
} from "./style";
import { Add, ErrorOutline } from "@mui/icons-material";
import { Button, Container, Tittle } from "./style";
import {
  Dialog,
  DialogTitle,
  FormControlLabel,
  LinearProgress,
  Radio,
  RadioGroup,
} from "@mui/material";
import { CssTextField, OptionSelect } from "../Enrollment/style";
import { OneColumn } from "../Enrollment/naturalPerson/step3/style";
import { FourColumn } from "../style";
const typeResponse = [
  { id: 0, name: "no" },
  { id: 1, name: "yes" },
];

const ManageGeneralInformation = () => {
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(true);
  const [alertVendInformation, setAlertVendInformation] = useState(true);
  const {
    vendorInformation,
    vendGeneralInformation,
    companyOwner,
    contractor,
    getVendorUpdGeneralInformation,
    sendVendGeneralInformation,
    sendCompanyOwner,
    sendContractor,
  } = useContext(VendorContext);
  const { currentContact } = useContext(ContactContext);
  const [localOwner, setLocalOwner] = useState({
    fulL_NAME_l: "",
    identification_l: "",
    percentage_l: "",
    nationality_l: "",
    country_l: "",
    entitY_ID_l: "",
    guiD_VEND_l: "",
  });
  const [localOwner2, setLocalOwner2] = useState({
    fulL_NAME_l: "",
    identification_l: "",
    percentage_l: "",
    nationality_l: "",
    country_l: "",
    entitY_ID_l: "",
    guiD_VEND_l: "",
  });
  const [localContractor, setLocalContractor] = useState({
    fulL_NAME_LC: "",
    identification_LC: "",
    service_LC: "",
  });

  const classesSx = stylesCss;
  const [messageError, setMessageError] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [nonNumber, setNonNumber] = useState(false);
  const [showDialogError, setShowDialogError] = useState(false);

  const handleInformation = (event) => {
    event.preventDefault();
    vendGeneralInformation[event.target.name] = event.target.value;
    sendVendGeneralInformation(vendGeneralInformation);
  };
  const handleInformationOtherName = (event) => {
    event.preventDefault();
    if (event.target.value === "0") {
      vendGeneralInformation["diferenT_NAME"] = "";
      vendGeneralInformation["ruc"] = "";
      vendGeneralInformation["tO_DATE"] = "";
    }
    handleInformation(event);
  };
  const handleOwnerInformation = (event) => {
    event.preventDefault();
    //comprueba si es un número
    if (event.target.name === "percentage_l" && isNaN(event.target.value)) {
      setNonNumber(true);
    } else if (
      event.target.name === "percentage_l" &&
      event.target.value > 100
    ) {
      setNonNumber(true);
    } else {
      setNonNumber(false);
      setLocalOwner({ ...localOwner, [event.target.name]: event.target.value });
    }
  };
  const handleAddLocalOwner = (e) => {
    e.preventDefault();
    if (
      localOwner.fulL_NAME_l &&
      localOwner.identification_l &&
      localOwner.nationality_l &&
      localOwner.percentage_l
    ) {
      setShowAlert(false);
      const newLocalOwner = {
        fulL_NAME: localOwner.fulL_NAME_l,
        identification: localOwner.identification_l,
        nationality: localOwner.nationality_l,
        percentage: localOwner.percentage_l,
        country: "",
        entitY_ID: "1",
        guiD_VEND: vendorInformation.guiD_PRIMARY_CONTACT,
      };
      sendCompanyOwner(newLocalOwner);
      setLocalOwner({
        fulL_NAME_l: "",
        identification_l: "",
        percentage_l: "",
        nationality_l: "",
        country_l: "",
        entitY_ID_l: "",
        guiD_VEND_l: "",
      });
    } else {
      setShowAlert(true);
    }
  };
  const handleOwnerInformation2 = (event) => {
    event.preventDefault();
    setLocalOwner2({ ...localOwner2, [event.target.name]: event.target.value });
  };
  const handleAddLocalOwner2 = (e) => {
    e.preventDefault();
    if (localOwner2.fulL_NAME_l && localOwner2.nationality_l) {
      setShowAlert(false);
      const newLocalOwner = {
        fulL_NAME: localOwner2.fulL_NAME_l,
        identification: "",
        nationality: localOwner2.nationality_l,
        percentage: "",
        country: "",
        entitY_ID: "2",
        guiD_VEND: vendorInformation.guiD_PRIMARY_CONTACT,
      };
      sendCompanyOwner(newLocalOwner);
      setLocalOwner2({
        fulL_NAME_l: "",
        identification_l: "",
        percentage_l: "",
        nationality_l: "",
        country_l: "",
        entitY_ID_l: "",
        guiD_VEND_l: "",
      });
    } else {
      setShowAlert(true);
    }
  };
  const handleContractorInformation = (event) => {
    event.preventDefault();
    setLocalContractor({
      ...localContractor,
      [event.target.name]: event.target.value,
    });
  };
  const handleAddLocalContractor = (e) => {
    e.preventDefault();
    if (
      localContractor.fulL_NAME_LC &&
      localContractor.identification_LC &&
      localContractor.service_LC
    ) {
      setShowAlert(false);
      const newVal = {
        entitY_ID: "1",
        fulL_NAME: localContractor.fulL_NAME_LC,
        identification: localContractor.identification_LC,
        service: localContractor.service_LC,
        guiD_VEND: vendorInformation.guiD_PRIMARY_CONTACT,
      };
      sendContractor(newVal);
      setLocalContractor({
        fulL_NAME_LC: "",
        identification_LC: "",
        service_LC: "",
      });
    } else {
      setShowAlert(true);
    }
  };
  const handleInformationWithDescription = (event, description) => {
    event.preventDefault();
    if (event.target.value === "0") {
      vendGeneralInformation[description] = "";
    }
    handleInformation(event);
  };
  const submitForm = async (e) => {
    e.preventDefault();
    if (vendorInformation.type === "2" && companyOwner.length <= 0) {
      setShowDialogError(true);
      setMessageError("alertIncompleteInformation");
    } else if (showAlert) {
      setShowDialogError(true);
      setMessageError("alertIncompleteInformation");
    } else if (
      vendGeneralInformation.questioN7_RESP === "1" &&
      contractor.length <= 0
    ) {
      setShowDialogError(true);
      setMessageError("alertIncompleteInformation");
    } else {
      setShowDialogError(false);
    }
  };
  const handleCloseDialog = (e, reason) => {
    setShowDialogError(false);
  };
  const handleCloseDialogVendInfo = (e, reason) => {
    setAlertVendInformation(false);
  };

  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getVendorUpdGeneralInformation(currentContact)]);
      setLoading(false);
    };
    fetchData2();
  }, []);

  if (isLoading) {
    return <LinearProgress color="error" />;
  }
  console.log(vendGeneralInformation);
  console.log(contractor);
  console.log(companyOwner);
  return (
    <>
      {showDialogError && (
        <Dialog
          open={showDialogError}
          onClose={(e, reason) => handleCloseDialog(e, reason)}
        >
          <DialogTitle>{t("incompleteInfo")}</DialogTitle>
          <ContentDialog>
            <BoxDialog>{t(messageError)}</BoxDialog>
          </ContentDialog>
          <ButtonCancel onClick={handleCloseDialog}>{t("close")}</ButtonCancel>
        </Dialog>
      )}
      {vendorInformation.type === "" || vendorInformation.type === null ? (
        <Dialog open={alertVendInformation} onClose={handleCloseDialogVendInfo}>
          <DialogTitle>{t("incompleteInfo")}</DialogTitle>
          <ContentDialog>
            <BoxDialog>{t("vendUpdInfoNotification")}</BoxDialog>
          </ContentDialog>
          <Button
            style={{ marginBottom: "15px" }}
            onClick={handleCloseDialogVendInfo}
          >
            {t("close")}
          </Button>
        </Dialog>
      ) : (
        /* 
        <Dialog onClose={handleCloseCountry} open={messageCountry}>
          <br />
          <Container>
            <H3>{t("notificationCountry")}</H3>
          </Container>
          <Container>
            <OneColumn>
              <SearchButton onClick={handleCloseCountry}>
                {t("close")}
              </SearchButton>
            </OneColumn>
          </Container>
        </Dialog>
        */
        <form onSubmit={submitForm}>
          <Root>
            <Tittle>{t("generalInformation")}</Tittle>
            {vendorInformation.type === "2" && (
              <>
                <BorderContainer>
                  <OneColumn>
                    <h5>{t("giQuestion0")}</h5>
                    <RadioGroup
                      id="questioN0_RESP"
                      name="questioN0_RESP"
                      onChange={(e) => handleInformationOtherName(e)}
                      sx={classesSx.radioGroup}
                      value={vendGeneralInformation.questioN0_RESP}
                    >
                      {typeResponse.map((item, index) => {
                        return (
                          <FormControlLabel
                            key={index}
                            value={item.id}
                            control={
                              <Radio
                                required={
                                  !vendGeneralInformation.questioN0_RESP
                                }
                                sx={classesSx.radio}
                              />
                            }
                            label={t(item.name)}
                          />
                        );
                      })}
                    </RadioGroup>
                  </OneColumn>

                  {vendGeneralInformation.questioN0_RESP === "1" && (
                    <>
                      <LabelH6>{t("describeBelow")}</LabelH6>
                      <br />
                      <ThreeColumn>
                        <CssTextField
                          type={"text"}
                          value={vendGeneralInformation.diferenT_NAME}
                          required={vendGeneralInformation.diferenT_NAME === ""}
                          fullWidth
                          label={t("fullName")}
                          id="diferenT_NAME"
                          name="diferenT_NAME"
                          onChange={(e) => handleInformation(e)}
                        />
                      </ThreeColumn>
                      <ThreeColumn>
                        <CssTextField
                          type={"text"}
                          value={vendGeneralInformation.ruc}
                          required={vendGeneralInformation.ruc === ""}
                          fullWidth
                          label={t("identityCard")}
                          id="ruc"
                          name="ruc"
                          onChange={(e) => handleInformation(e)}
                        />
                      </ThreeColumn>
                      <ThreeColumn>
                        <CssTextField
                          type="date"
                          id="tO_DATE"
                          name="tO_DATE"
                          label={t("toDate")}
                          value={vendGeneralInformation.tO_DATE}
                          required={vendGeneralInformation.tO_DATE === ""}
                          fullWidth
                          onChange={(e) => handleInformation(e)}
                        />
                      </ThreeColumn>
                    </>
                  )}
                </BorderContainer>
                <BorderContainer>
                  <br />
                  <H5>{t("giQuestion1")}</H5>
                  <br />
                  <FourColumn>
                    <CssTextField
                      type={"text"}
                      required={showAlert && localOwner.fulL_NAME_l === ""}
                      fullWidth
                      value={localOwner.fulL_NAME_l}
                      id="fulL_NAME_l"
                      name="fulL_NAME_l"
                      label={t("giQuestion1_1")}
                      onChange={(e) => handleOwnerInformation(e)}
                    />
                    {showAlert && localOwner.fulL_NAME_l === "" && (
                      <AlertSpan>
                        <ErrorOutline /> {t("incompleteInfo")}
                      </AlertSpan>
                    )}
                  </FourColumn>
                  <FourColumn>
                    <CssTextField
                      type={"text"}
                      required={showAlert && localOwner.identification_l === ""}
                      fullWidth
                      value={localOwner.identification_l}
                      id="identification_l"
                      name="identification_l"
                      label={t("giQuestion1_2")}
                      onChange={(e) => handleOwnerInformation(e)}
                    />
                    {showAlert && localOwner.identification_l === "" && (
                      <AlertSpan>
                        <ErrorOutline /> {t("incompleteInfo")}
                      </AlertSpan>
                    )}
                  </FourColumn>
                  <FourColumn>
                    <CssTextField
                      type={"text"}
                      required={showAlert && localOwner.percentage_l === ""}
                      fullWidth
                      value={localOwner.percentage_l}
                      id="percentage_l"
                      name="percentage_l"
                      label={t("giQuestion1_3")}
                      onChange={(e) => handleOwnerInformation(e)}
                    />
                    {showAlert && localOwner.percentage_l === "" && (
                      <AlertSpan>
                        <ErrorOutline /> {t("incompleteInfo")}
                      </AlertSpan>
                    )}
                    {nonNumber && localOwner.percentage_l === "" && (
                      <AlertSpan>
                        <ErrorOutline /> {t("incorrectValue")}
                      </AlertSpan>
                    )}
                  </FourColumn>
                  <FourColumn>
                    <CssTextField
                      type={"text"}
                      required={showAlert && localOwner.nationality_l === ""}
                      fullWidth
                      value={localOwner.nationality_l}
                      id="nationality_l"
                      name="nationality_l"
                      label={t("nationality")}
                      onChange={(e) => handleOwnerInformation(e)}
                    />
                    {showAlert && localOwner.nationality_l === "" && (
                      <AlertSpan>
                        <ErrorOutline /> {t("incompleteInfo")}
                      </AlertSpan>
                    )}
                  </FourColumn>
                  <OneColumn>
                    <AddButton onClick={handleAddLocalOwner}>
                      {t("add")}
                      <Add />
                    </AddButton>
                  </OneColumn>
                  {companyOwner.filter((item) => item.entitY_ID === "1")
                    .length > 0 && <LabelH6>{t("owners")} :</LabelH6>}
                  {companyOwner
                    .filter((item) => item.entitY_ID === "1")
                    .map((item, index) => {
                      return (
                        <ContractorContainer key={index}>
                          <ContractorThreeColumn>
                            <ContractorCssTextField
                              type={"text"}
                              disabled
                              fullWidth
                              value={item.fulL_NAME}
                              label={t("giQuestion1_1")}
                            />
                          </ContractorThreeColumn>
                          <ContractorThreeColumn>
                            <ContractorCssTextField
                              type={"text"}
                              disabled
                              fullWidth
                              value={item.identification}
                              label={t("giQuestion1_2")}
                            />
                          </ContractorThreeColumn>
                          <ContractorThreeColumn>
                            <ContractorCssTextField
                              type={"text"}
                              disabled
                              fullWidth
                              value={item.percentage}
                              label={t("giQuestion1_3")}
                            />
                          </ContractorThreeColumn>
                        </ContractorContainer>
                      );
                    })}
                </BorderContainer>
                <BorderContainer>
                  <br />
                  <H5>{t("giQuestion2")}</H5>
                  <br />
                  <TwoColumn>
                    <CssTextField
                      type={"text"}
                      required={showAlert && localOwner2.fulL_NAME_l === ""}
                      fullWidth
                      value={localOwner2.fulL_NAME_l}
                      id="fulL_NAME_l"
                      name="fulL_NAME_l"
                      label={t("fullName")}
                      onChange={(e) => handleOwnerInformation2(e)}
                    />
                    {showAlert && localOwner2.fulL_NAME_l === "" && (
                      <AlertSpan>
                        <ErrorOutline /> {t("incompleteInfo")}
                      </AlertSpan>
                    )}
                  </TwoColumn>
                  <TwoColumn>
                    <CssTextField
                      type={"text"}
                      required={showAlert && localOwner2.nationality_l === ""}
                      fullWidth
                      value={localOwner2.nationality_l}
                      id="nationality_l"
                      name="nationality_l"
                      label={t("nationality") + " / " + t("countryOperations")}
                      onChange={(e) => handleOwnerInformation2(e)}
                    />
                    {showAlert && localOwner2.nationality_l === "" && (
                      <AlertSpan>
                        <ErrorOutline /> {t("incompleteInfo")}
                      </AlertSpan>
                    )}
                  </TwoColumn>
                  <OneColumn>
                    <AddButton onClick={handleAddLocalOwner2}>
                      {t("add")}
                      <Add />
                    </AddButton>
                  </OneColumn>
                  {companyOwner.filter((item) => item.entitY_ID === "2")
                    .length > 0 && <LabelH6>{t("personEntity")} :</LabelH6>}
                  {companyOwner
                    .filter((item) => item.entitY_ID === "2")
                    .map((item, index) => {
                      return (
                        <ContractorContainer key={index}>
                          <TwoColumn>
                            <ContractorCssTextField
                              type={"text"}
                              disabled
                              fullWidth
                              value={item.fulL_NAME}
                              label={t("fullName")}
                            />
                          </TwoColumn>
                          <TwoColumn>
                            <ContractorCssTextField
                              type={"text"}
                              disabled
                              fullWidth
                              value={item.nationality}
                              label={
                                t("nationality") +
                                " / " +
                                t("countryOperations")
                              }
                            />
                          </TwoColumn>
                        </ContractorContainer>
                      );
                    })}
                </BorderContainer>
                <BorderContainer>
                  <OneColumn>
                    <h5>{t("giQuestion3")}</h5>
                    <RadioGroup
                      id="questioN3_RESP"
                      name="questioN3_RESP"
                      onChange={(e) =>
                        handleInformationWithDescription(
                          e,
                          "questioN3_DESCRIPTION"
                        )
                      }
                      sx={classesSx.radioGroup}
                      value={vendGeneralInformation.questioN3_RESP}
                    >
                      {typeResponse.map((item, index) => {
                        return (
                          <FormControlLabel
                            key={index}
                            value={item.id}
                            control={
                              <Radio
                                required={
                                  !vendGeneralInformation.questioN3_RESP
                                }
                                sx={classesSx.radio}
                              />
                            }
                            label={t(item.name)}
                          />
                        );
                      })}
                    </RadioGroup>
                    {vendGeneralInformation.questioN3_RESP === "1" && (
                      <>
                        <br />
                        <CssTextField
                          value={vendGeneralInformation.questioN3_DESCRIPTION}
                          multiline
                          type={"text"}
                          required
                          fullWidth
                          label={t("describeBelow")}
                          id="questioN3_DESCRIPTION"
                          name="questioN3_DESCRIPTION"
                          onChange={(e) => handleInformation(e)}
                        />
                      </>
                    )}
                  </OneColumn>
                </BorderContainer>
                <BorderContainer>
                  <OneColumn>
                    <h5>{t("giQuestion4")}</h5>
                    <RadioGroup
                      id="questioN4_RESP"
                      name="questioN4_RESP"
                      onChange={(e) =>
                        handleInformationWithDescription(
                          e,
                          "questioN4_DESCRIPTION"
                        )
                      }
                      sx={classesSx.radioGroup}
                      value={vendGeneralInformation.questioN4_RESP}
                    >
                      {typeResponse.map((item, index) => {
                        return (
                          <FormControlLabel
                            key={index}
                            value={item.id}
                            control={
                              <Radio
                                required={
                                  !vendGeneralInformation.questioN4_RESP
                                }
                                sx={classesSx.radio}
                              />
                            }
                            label={t(item.name)}
                          />
                        );
                      })}
                    </RadioGroup>
                    {vendGeneralInformation.questioN4_RESP === "1" && (
                      <>
                        <br />
                        <CssTextField
                          value={vendGeneralInformation.questioN4_DESCRIPTION}
                          multiline
                          type={"text"}
                          required
                          fullWidth
                          label={t("describeBelow")}
                          id="questioN4_DESCRIPTION"
                          name="questioN4_DESCRIPTION"
                          onChange={(e) => handleInformation(e)}
                        />
                      </>
                    )}
                  </OneColumn>
                </BorderContainer>
                <BorderContainer>
                  <OneColumn>
                    <h5>{t("giQuestion5")}</h5>
                    <RadioGroup
                      id="questioN5_RESP"
                      name="questioN5_RESP"
                      onChange={(e) =>
                        handleInformationWithDescription(
                          e,
                          "questioN5_DESCRIPTION"
                        )
                      }
                      sx={classesSx.radioGroup}
                      value={vendGeneralInformation.questioN5_RESP}
                    >
                      {typeResponse.map((item, index) => {
                        return (
                          <FormControlLabel
                            key={index}
                            value={item.id}
                            control={
                              <Radio
                                required={
                                  !vendGeneralInformation.questioN5_RESP
                                }
                                sx={classesSx.radio}
                              />
                            }
                            label={t(item.name)}
                          />
                        );
                      })}
                    </RadioGroup>
                    {vendGeneralInformation.questioN5_RESP === "1" && (
                      <>
                        <br />
                        <CssTextField
                          value={vendGeneralInformation.questioN5_DESCRIPTION}
                          multiline
                          type={"text"}
                          required
                          fullWidth
                          label={t("describeBelow")}
                          id="questioN5_DESCRIPTION"
                          name="questioN5_DESCRIPTION"
                          onChange={(e) => handleInformation(e)}
                        />
                      </>
                    )}
                  </OneColumn>
                </BorderContainer>
              </>
            )}
            {/* desde aqui Natural */}
            <BorderContainer>
              <OneColumn>
                <h5>{t("giQuestion6")}</h5>
                <RadioGroup
                  id="questioN6_RESP"
                  name="questioN6_RESP"
                  onChange={(e) =>
                    handleInformationWithDescription(e, "questioN6_DESCRIPTION")
                  }
                  sx={classesSx.radioGroup}
                  value={vendGeneralInformation.questioN6_RESP}
                >
                  {typeResponse.map((item, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        value={item.id}
                        control={
                          <Radio
                            required={!vendGeneralInformation.questioN6_RESP}
                            sx={classesSx.radio}
                          />
                        }
                        label={t(item.name)}
                      />
                    );
                  })}
                </RadioGroup>
                {vendGeneralInformation.questioN6_RESP === "1" && (
                  <>
                    <br />
                    <CssTextField
                      value={vendGeneralInformation.questioN6_DESCRIPTION}
                      multiline
                      type={"text"}
                      required
                      fullWidth
                      label={t("describeBelow")}
                      id="questioN6_DESCRIPTION"
                      name="questioN6_DESCRIPTION"
                      onChange={(e) => handleInformation(e)}
                    />
                  </>
                )}
              </OneColumn>
            </BorderContainer>
            <BorderContainer>
              <OneColumn>
                <h5>{t("giQuestion7")}</h5>
                <RadioGroup
                  id="questioN7_RESP"
                  name="questioN7_RESP"
                  onChange={(e) => handleInformation(e)}
                  sx={classesSx.radioGroup}
                  value={vendGeneralInformation.questioN7_RESP}
                >
                  {typeResponse.map((item, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        value={item.id}
                        control={
                          <Radio
                            required={!vendGeneralInformation.questioN7_RESP}
                            sx={classesSx.radio}
                          />
                        }
                        label={t(item.name)}
                      />
                    );
                  })}
                </RadioGroup>
              </OneColumn>
              {vendGeneralInformation.questioN7_RESP === "1" && (
                <>
                  <LabelH6>{t("detailsContractors")}</LabelH6>
                  <br />
                  <ThreeColumn>
                    <CssTextField
                      type={"text"}
                      value={localContractor.fulL_NAME_LC}
                      required={
                        showAlert && localContractor.fulL_NAME_LC === ""
                      }
                      fullWidth
                      label={t("fullName")}
                      id="fulL_NAME_LC"
                      name="fulL_NAME_LC"
                      onChange={(e) => handleContractorInformation(e)}
                    />
                    {showAlert && localContractor.fulL_NAME_LC === "" && (
                      <AlertSpan>
                        <ErrorOutline /> {t("incompleteInfo")}
                      </AlertSpan>
                    )}
                  </ThreeColumn>
                  <ThreeColumn>
                    <CssTextField
                      type={"text"}
                      value={localContractor.identification_LC}
                      required={
                        showAlert && localContractor.identification_LC === ""
                      }
                      fullWidth
                      label={t("identityCard")}
                      id="identification_LC"
                      name="identification_LC"
                      onChange={(e) => handleContractorInformation(e)}
                    />
                    {showAlert && localContractor.identification_LC === "" && (
                      <AlertSpan>
                        <ErrorOutline /> {t("incompleteInfo")}
                      </AlertSpan>
                    )}
                  </ThreeColumn>
                  <ThreeColumn>
                    <CssTextField
                      multiline
                      type={"text"}
                      value={localContractor.service_LC}
                      required={showAlert && localContractor.service_LC === ""}
                      fullWidth
                      label={t("serviceBeProvided")}
                      id="service_LC"
                      name="service_LC"
                      onChange={(e) => handleContractorInformation(e)}
                    />
                    {showAlert && localContractor.service_LC === "" && (
                      <AlertSpan>
                        <ErrorOutline /> {t("incompleteInfo")}
                      </AlertSpan>
                    )}
                  </ThreeColumn>
                  <OneColumn>
                    <AddButton onClick={handleAddLocalContractor}>
                      {t("add")}
                      <Add />
                    </AddButton>
                  </OneColumn>
                  {contractor.length > 0 && (
                    <LabelH6>{t("subcontractors")} :</LabelH6>
                  )}
                  {contractor.map((item, index) => {
                    return (
                      <ContractorContainer key={index}>
                        <ContractorThreeColumn>
                          <ContractorCssTextField
                            type={"text"}
                            disabled
                            fullWidth
                            value={item.fulL_NAME}
                            label={t("name")}
                          />
                        </ContractorThreeColumn>
                        <ContractorThreeColumn>
                          <ContractorCssTextField
                            type={"text"}
                            disabled
                            fullWidth
                            value={item.identification}
                            label={t("identityCard")}
                          />
                        </ContractorThreeColumn>
                        <ContractorThreeColumn>
                          <ContractorCssTextField
                            type={"text"}
                            disabled
                            fullWidth
                            value={item.service}
                            label={t("serviceBeProvided")}
                          />
                        </ContractorThreeColumn>
                      </ContractorContainer>
                    );
                  })}
                </>
              )}
            </BorderContainer>
            <BorderContainer>
              <OneColumn>
                <h5>{t("giQuestion8")}</h5>
                <RadioGroup
                  id="questioN8_RESP"
                  name="questioN8_RESP"
                  onChange={(e) => handleInformation(e)}
                  sx={classesSx.radioGroup}
                  value={vendGeneralInformation.questioN8_RESP}
                >
                  {typeResponse.map((item, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        value={item.id}
                        control={
                          <Radio
                            required={!vendGeneralInformation.questioN8_RESP}
                            sx={classesSx.radio}
                          />
                        }
                        label={t(item.name)}
                      />
                    );
                  })}
                </RadioGroup>
              </OneColumn>
            </BorderContainer>
            {vendorInformation.type === "2" && (
              <>
                <BorderContainer>
                  <OneColumn>
                    <h5>{t("fliQuestion1_1")}</h5>
                    <RadioGroup
                      id="fliquestioN1_1_RESP"
                      name="fliquestioN1_1_RESP"
                      onChange={(e) =>
                        handleInformationWithDescription(
                          e,
                          "fliquestioN1_1_DESCRIPTION"
                        )
                      }
                      sx={classesSx.radioGroup}
                      value={vendGeneralInformation.fliquestioN1_1_RESP}
                    >
                      {typeResponse.map((item, index) => {
                        return (
                          <FormControlLabel
                            key={index}
                            value={item.id}
                            control={
                              <Radio
                                required={
                                  !vendGeneralInformation.fliquestioN1_1_RESP
                                }
                                sx={classesSx.radio}
                              />
                            }
                            label={t(item.name)}
                          />
                        );
                      })}
                    </RadioGroup>
                    {vendGeneralInformation.fliquestioN1_1_RESP === "1" && (
                      <>
                        <br />
                        <CssTextField
                          value={
                            vendGeneralInformation.fliquestioN1_1_DESCRIPTION
                          }
                          multiline
                          type={"text"}
                          required
                          fullWidth
                          label={t("describeBelow")}
                          id="fliquestioN1_1_DESCRIPTION"
                          name="fliquestioN1_1_DESCRIPTION"
                          onChange={(e) => handleInformation(e)}
                        />
                      </>
                    )}
                  </OneColumn>
                </BorderContainer>
              </>
            )}
            {vendorInformation.type === "1" && (
              <>
                <BorderContainer>
                  <OneColumn>
                    <h5>{t("fliQuestion1")}</h5>
                    <RadioGroup
                      id="fliquestioN1_RESP"
                      name="fliquestioN1_RESP"
                      onChange={(e) =>
                        handleInformationWithDescription(
                          e,
                          "fliquestioN1_DESCRIPTION"
                        )
                      }
                      sx={classesSx.radioGroup}
                      value={vendGeneralInformation.fliquestioN1_RESP}
                    >
                      {typeResponse.map((item, index) => {
                        return (
                          <FormControlLabel
                            key={index}
                            value={item.id}
                            control={
                              <Radio
                                required={
                                  !vendGeneralInformation.fliquestioN1_RESP
                                }
                                sx={classesSx.radio}
                              />
                            }
                            label={t(item.name)}
                          />
                        );
                      })}
                    </RadioGroup>
                    {vendGeneralInformation.fliquestioN1_RESP === "1" && (
                      <>
                        <br />
                        <CssTextField
                          value={
                            vendGeneralInformation.fliquestioN1_DESCRIPTION
                          }
                          multiline
                          type={"text"}
                          required
                          fullWidth
                          label={t("describeBelow")}
                          id="fliquestioN1_DESCRIPTION"
                          name="fliquestioN1_DESCRIPTION"
                          onChange={(e) => handleInformation(e)}
                        />
                      </>
                    )}
                  </OneColumn>
                </BorderContainer>
              </>
            )}
            <BorderContainer>
              <OneColumn>
                <h5>{t("fliQuestion2")}</h5>
                <RadioGroup
                  id="fliquestioN2_RESP"
                  name="fliquestioN2_RESP"
                  onChange={(e) =>
                    handleInformationWithDescription(
                      e,
                      "fliquestioN2_DESCRIPTION"
                    )
                  }
                  sx={classesSx.radioGroup}
                  value={vendGeneralInformation.fliquestioN2_RESP}
                >
                  {typeResponse.map((item, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        value={item.id}
                        control={
                          <Radio
                            required={!vendGeneralInformation.fliquestioN2_RESP}
                            sx={classesSx.radio}
                          />
                        }
                        label={t(item.name)}
                      />
                    );
                  })}
                </RadioGroup>
                {vendGeneralInformation.fliquestioN2_RESP === "1" && (
                  <>
                    <br />
                    <CssTextField
                      value={vendGeneralInformation.fliquestioN2_DESCRIPTION}
                      multiline
                      type={"text"}
                      required
                      fullWidth
                      label={t("describeBelow")}
                      id="fliquestioN2_DESCRIPTION"
                      name="fliquestioN2_DESCRIPTION"
                      onChange={(e) => handleInformation(e)}
                    />
                  </>
                )}
              </OneColumn>
            </BorderContainer>
            <BorderContainer>
              <OneColumn>
                <h5>{t("fliQuestion3")}</h5>
                <RadioGroup
                  id="fliquestioN3_RESP"
                  name="fliquestioN3_RESP"
                  onChange={(e) =>
                    handleInformationWithDescription(
                      e,
                      "fliquestioN3_DESCRIPTION"
                    )
                  }
                  sx={classesSx.radioGroup}
                  value={vendGeneralInformation.fliquestioN3_RESP}
                >
                  {typeResponse.map((item, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        value={item.id}
                        control={
                          <Radio
                            required={!vendGeneralInformation.fliquestioN3_RESP}
                            sx={classesSx.radio}
                          />
                        }
                        label={t(item.name)}
                      />
                    );
                  })}
                </RadioGroup>
                {vendGeneralInformation.fliquestioN3_RESP === "1" && (
                  <>
                    <br />
                    <CssTextField
                      value={vendGeneralInformation.fliquestioN3_DESCRIPTION}
                      multiline
                      type={"text"}
                      required
                      fullWidth
                      label={t("describeBelow")}
                      id="fliquestioN3_DESCRIPTION"
                      name="fliquestioN3_DESCRIPTION"
                      onChange={(e) => handleInformation(e)}
                    />
                  </>
                )}
              </OneColumn>
            </BorderContainer>
            <BorderContainer>
              <OneColumn>
                <h5>{t("fliQuestion4")}</h5>
                <RadioGroup
                  id="fliquestioN4_RESP"
                  name="fliquestioN4_RESP"
                  onChange={(e) =>
                    handleInformationWithDescription(
                      e,
                      "fliquestioN4_DESCRIPTION"
                    )
                  }
                  sx={classesSx.radioGroup}
                  value={vendGeneralInformation.fliquestioN4_RESP}
                >
                  {typeResponse.map((item, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        value={item.id}
                        control={
                          <Radio
                            required={!vendGeneralInformation.fliquestioN4_RESP}
                            sx={classesSx.radio}
                          />
                        }
                        label={t(item.name)}
                      />
                    );
                  })}
                </RadioGroup>
                {vendGeneralInformation.fliquestioN4_RESP === "1" && (
                  <>
                    <br />
                    <CssTextField
                      value={vendGeneralInformation.fliquestioN4_DESCRIPTION}
                      multiline
                      type={"text"}
                      required
                      fullWidth
                      label={t("describeBelow")}
                      id="fliquestioN4_DESCRIPTION"
                      name="fliquestioN4_DESCRIPTION"
                      onChange={(e) => handleInformation(e)}
                    />
                  </>
                )}
              </OneColumn>
            </BorderContainer>

            <Container>
              <OneColumn>
                <Button type="submit">
                  {t("update")} <SaveIcon />
                </Button>
              </OneColumn>
            </Container>
          </Root>
        </form>
      )}
    </>
  );
};

export default ManageGeneralInformation;
